import { parse } from 'date-fns';
import { DATE_TIME_FORMAT } from '../../../../constants';
import { ReportSettingAPState } from '../AP';

export const getReportEndDateAp = (
  reportSettingState: ReportSettingAPState,
): Date => {
  const { to } = reportSettingState;
  return parse(to, DATE_TIME_FORMAT.FULL_DATE, new Date());
};
